/**
 * Plugin provides decorator to DTOptionsBuilder service and updates datatables wrapper with specific class
 * Should be used with datatables-ibm-theme.css
 *
 * Example of building options:
 *
 * var options = DTOptionsBuilder.newOptions().withIBMTheme()
 */
angular
    .module("datatables.ibmTheme", [
    "datatables",
    "datatables.alphabet",
    "datatables.fieldsSearch"
])
    .config(function ($provide) {
    $provide.decorator("DTOptionsBuilder", optionsDecorator);
    function optionsDecorator($delegate) {
        var newOptions = $delegate.newOptions;
        $delegate.newOptions = function () {
            var options = newOptions();
            options.withIBMTheme = function () {
                options.isIBMTheme = true;
                options.withDOM('<"info"F<"info-container"Ali>><"table-container"t>p');
                return options;
            };
            return options;
        };
        return $delegate;
    }
})
    .run(function (DTRendererService) {
    var ibmThemePlugin = {
        postRender: postRender
    };
    DTRendererService.registerPlugin(ibmThemePlugin);
    function postRender(options, result) {
        if (options && options.isIBMTheme) {
            var container = result.dataTable
                .api()
                .table()
                .container();
            $(container).addClass("datatables-ibm-theme");
        }
    }
});

//# sourceMappingURL=datatables-ibm-theme.js.map
